import styled from "@emotion/styled"
import { Checkbox } from "@mui/material"
import Link from "next/link"
import { CheckboxIcon, CheckedCheckboxIcon, EyeIcon, NewText } from "ui"
import { extractProperty, getUmbracoMediaUrl } from "utils"

type FileItemProps = {
  file: any
  uniqueId: string
  isSelected: boolean
  onSelectionChange: any
}

const StyledOpenFileItem = styled.div`
  box-shadow: 0px 4px 12px 0px #00000029;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
  align-items: center;
  a {
    display: flex;
    align-items: center;
  }
`

const StyledTextDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

const StyledLink = styled(Link)``

const FileItem = ({ file, uniqueId, isSelected, onSelectionChange }: FileItemProps) => {
  return (
    <StyledOpenFileItem>
      <StyledTextDiv>
        <Checkbox
          icon={<CheckboxIcon />}
          checkedIcon={<CheckedCheckboxIcon color="#2768A3" />}
          checked={isSelected}
          onChange={(e) => onSelectionChange(file, uniqueId, e.target.checked)}
        />
        <NewText component={"p"} desktopFontSize={16} color="#000000">
          {extractProperty(file, "fileName")}{" "}
          <span style={{ color: "#B5BFC9", paddingLeft: "4px", paddingRight: "4px" }}>|</span>{" "}
          {extractProperty(file, "fileTipe")}
        </NewText>
      </StyledTextDiv>
      <StyledLink href={getUmbracoMediaUrl(extractProperty(file, "uploadFile"))} target="_blank">
        <EyeIcon />
      </StyledLink>
    </StyledOpenFileItem>
  )
}

export default FileItem
